import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ToasterService } from 'angular2-toaster';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../../services/auth.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { ProjectManagerService } from '../../../../services/project-manager.service';
import { ProjectSaveService } from '../../../../services/project-save.service';
import { ModalSaveComponent } from '../../modal-save/modal-save.component';
import { Location } from '@angular/common';
import { GetQuoteResourceService } from '../services/get-quote-resource.service';
import { catchError, map } from 'rxjs/operators';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

@Component({
  selector: 'app-modal-get-quote-dealers',
  templateUrl: './modal-get-quote-dealers.component.html',
  styleUrls: ['./modal-get-quote-dealers.component.scss']
})
export class ModalGetQuoteDealersComponent implements OnInit {
  form: FormGroup;
  projectName: string;
  isSaved: boolean;
  isAuthorization: boolean = true;
  saveAsNewProject = false;
  saveInProgress = false;
  admin = false;
  initSubscription: Subscription;
  showLoading = false;
  @Input() dealersData;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ModalSaveComponent>,
    private auth: AuthService,
    private projectManagerService: ProjectManagerService,
    private toasterService: ToasterService,
    private location: Location,
    private loadingSpinnerService: LoadingSpinnerService,
    private saveProjectService: ProjectSaveService,
    private fb: FormBuilder,
    private authService: AuthService,
    private getQuoteResourceService: GetQuoteResourceService,
  ) {
    this.loadingSpinnerService.loaderActive.subscribe(value => {
      this.saveInProgress = value;
    });
  }

  private _createForm() {
    this.form = this.fb.group({
      dealers: this.fb.array([]),
      selected: ''
    });
    console.log('this.dealers from dealers', this.dealersData);
    console.log('this.data', this.data);
    // for (let i = 0; i < this.data.dealers.length; i++) {
    for (let i = 0; i < this.dealersData.dealers.length; i++) {
      (<FormArray>this.form.get('dealers')).push(
        this.fb.group({
          id: [this.dealersData.dealers[i].id],
          companyName: [this.dealersData.dealers[i].values.companyname],
          addressAddress1: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'address1')],
          addressCity: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'city')],
          addressState: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'state')[0]['text']],
          addressZipcode: [this.dealersData.getAddress(this.dealersData.dealers[i].values, 'zipcode')],
          url: [this.dealersData.dealers[i].values['url']],
          phone: [this.dealersData.dealers[i].values['phone']],
          distance: [this.dealersData.dealers[i].values['formulanumeric']],
          mapSearchUrl: this.dealersData.dealers[i].mapSearchUrl
        })
        // this.fb.group({
        //   id: [this.data.dealers[i].id],
        //   companyName: [this.data.dealers[i].values.companyname],
        //   addressAddress1: [this.data.getAddress(this.data.dealers[i].values, 'address1')],
        //   addressCity: [this.data.getAddress(this.data.dealers[i].values, 'city')],
        //   addressState: [this.data.getAddress(this.data.dealers[i].values, 'state')[0]['text']],
        //   addressZipcode: [this.data.getAddress(this.data.dealers[i].values, 'zipcode')],
        //   url: [this.data.dealers[i].values['url']],
        //   phone: [this.data.dealers[i].values['phone']],
        //   distance: [this.data.dealers[i].values['formulanumeric']],
        //   mapSearchUrl: this.data.dealers[i].mapSearchUrl
        // })
      );
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onSubmit() {
    const dealer = this.data.dealers.find(d => d.id === this.form.get('selected').value);
    const user = this.authService.getUser();
    this.showLoading = true;
    this.getQuoteResourceService
      .chooseDealer({
        dealer,
        comments: this.data.comments,
        userId: user.id,
        projectUrl: this.data.projectUrl,
        zipCode: this.data.zipCode
      })
      .pipe(
        map(res => {
          this.showLoading = false;
          this.dialogRef.close({
            dealer: res.dealer
          });
        }),
        catchError(err => {
          this.showLoading = false;
          return ErrorObservable.create('Error chosing dealer');
        })
      )
      .subscribe();
  }

  ngOnInit() {
    this._createForm();
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-get-quote/modal-get-quote-dealers/modal-get-quote-dealers.component.ts